export const canProcessIdAndSelfie = (verification) => {
  return verification.status === "submitted" && !verification.id_validated;
}

export const canProcessWorkSamples = (verification) => {
  return verification.status === "submitted" && verification.id_validated;
}

export const getPrepopulatedWrapupMsgOpts = ({ user, wrapup, project, step }) => {
  if (!user.is_staff || !wrapup.award || !project.id) {
    return [];
  }

  if (step === "proofs") {
    return [{
      label: "Approve proofs note",
      content: `Hi ${project.client_billing_name},

If you need changes to the proofs, please let ${wrapup.creative.username} know what changes you need.
If the proofs are good, please click the green "Approve proofs and move to next step" button so that ${wrapup.creative.username} can prepare final files for you.

Thanks,
the crowdspring crew`
    }, {
      label: "Approve proofs 48-hour notice",
      content: `Hi ${project.client_billing_name},

This is important.

We'll extend the courtesy of 48 more hours for you to take action in wrap-up.
If you need changes to the proofs, please let ${wrapup.creative.username} know what changes you need.
If the proofs are good, please click the green "Approve proofs and move to next step" button so that ${wrapup.creative.username} can prepare final files for you.
Our team is prepared to step in and complete the wrap-up with ${wrapup.creative.username}, but we'd obviously much prefer (as would ${wrapup.creative.username}) that you do that directly.

Thanks,
the crowdspring crew`
    }];
  }


  if (step === "final_files") {
    return [{
      label: "Approve final files note",
      content: `Hi ${project.client_billing_name},

If you need changes to the final files, please let ${wrapup.creative.username} know what changes you need.
If the files are good, please click the green "Approve final files and move to next step" button so that ${wrapup.creative.username} can be paid for their hard work in this project.

Thanks,
the crowdspring crew`
    }, {
      label: "Approve final files 48-hour notice",
      content: `Hi ${project.client_billing_name},

This is important.

We'll extend the courtesy of 48 more hours for you to take action in wrap-up.
If you need changes to final files, please let ${wrapup.creative.username} know what changes you need.
If the files are good, please click the green "Approve final files and move to next step" button so that ${wrapup.creative.username} can be paid. This wrapup-up is substantially overdue and as you know, ${wrapup.creative.username} cannot be paid until the wrap-up is completed.
Our team is prepared to step in and complete the wrap-up with ${wrapup.creative.username}, but we'd obviously much prefer (as would ${wrapup.creative.username}) that you do that directly.

Thanks,
the crowdspring crew`
    }];
  }

  if (step === "final_name") {
    return [{
      label: "Approve name 48-hour notice",
      content: `Hi ${project.client_billing_name},

This is important.

We'll extend the courtesy of 48 more hours for you to take action in wrap-up.
Please click the green "Approve name and move to next step" button so that ${wrapup.creative.username} can be paid.
This wrapup-up is substantially overdue and as you know, ${wrapup.creative.username} cannot be paid until the wrap-up is completed.
Our team is prepared to step in and complete the wrap-up with ${wrapup.creative.username}, but we'd obviously much prefer (as would ${wrapup.creative.username}) that you do that directly.

Thanks,
the crowdspring crew`
    }];
  }

  return [];
}



// WEBPACK FOOTER //
// ./admin/utils.js